module.exports = __webpack_public_path__ + "static/media/vegitables_37.758b4da0.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_37.csv
// module id = 621
// module chunks = 0